import { SavingsGoalOutcome } from "../../../services";
import { GoalTone } from "./types";

export const MISSING_VALUE = "—";

export const OUTCOME_LABEL: Record<SavingsGoalOutcome, string> = {
  REACHED: "Reached",
  MISSED: "Missed",
};

export const OUTCOME_TONE: Record<SavingsGoalOutcome, GoalTone> = {
  REACHED: "success",
  MISSED: "error",
};
